import { useSelector } from "../../../../redux-store";
import { useState } from "react";
import { selectNameExists } from "../../../../ducks/data/client-order-templates/selectors";
import { Dialog, DialogActions, DialogContent } from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import { DoraTextInput, DoraButton } from "dora-shared/frontend";
import { useTranslation } from "react-i18next";

const ClientCargoTemplateSelectNameDialog = (props: {
  onClose: () => void;
  onSubmit: (name: string) => void;
  clientId: string;
  existingTemplateToRename?: { id: string; name: string };
  buttonsDisabled?: boolean;
}) => {
  const {
    buttonsDisabled,
    existingTemplateToRename,
    clientId,
    onClose,
    onSubmit,
  } = props;
  const { t } = useTranslation(["orderTemplates", "components"]);
  const [name, setName] = useState(existingTemplateToRename?.name || "");
  const [inputChanged, setInputChanged] = useState(false);
  const nameExists = useSelector(
    selectNameExists(clientId, name, existingTemplateToRename?.id)
  );

  const onSetName = (value: string) => {
    setInputChanged(true);
    setName(value);
  };

  const renameExisting = t("orderTemplates:renameExisting");
  const nameNew = t("orderTemplates:nameNew");

  const title = existingTemplateToRename ? renameExisting : nameNew;

  return (
    <Dialog open onClose={onClose}>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit(name);
        }}
      >
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DoraTextInput
            autoFocus
            value={name}
            onChange={onSetName}
            placeholder={t("orderTemplates:nameNewPlaceholder")}
          />
          {nameExists && inputChanged && (
            <div className="text-red-500 mt-2">
              {t("orderTemplates:saveModal.nameExists")}
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <DoraButton
            variant={"primary-filled"}
            onClick={() => onSubmit(name)}
            disabled={!name || buttonsDisabled || nameExists}
          >
            {t("components:buttonLabels.save")}
          </DoraButton>
          <DoraButton variant={"primary"} onClick={onClose}>
            {t("components:buttonLabels.cancel")}
          </DoraButton>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default ClientCargoTemplateSelectNameDialog;
